import { render, staticRenderFns } from "./personalMessage.vue?vue&type=template&id=63b858ec&scoped=true&"
import script from "./personalMessage.vue?vue&type=script&lang=js&"
export * from "./personalMessage.vue?vue&type=script&lang=js&"
import style0 from "./personalMessage.vue?vue&type=style&index=0&id=63b858ec&prod&lang=scss&scoped=true&"
import style1 from "./personalMessage.vue?vue&type=style&index=1&id=63b858ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b858ec",
  null
  
)

export default component.exports